import styled from "styled-components";

export const StyledBody = styled.div`
  display : flex;
  flex-direction : row;
  justify-content : space-between;
  /* For below 768px screen width Jimmy */
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`